import React, { PropTypes, PureComponent } from 'react';
import { TileLayer } from 'react-leaflet';
import MapControl from '../MapControl';
import Switch from '../Switch';

/*
* The basemap component checks if the map should render a basemap layer.
* If there are multiple basemaps, it checks the current active layer and renders it.
*/

class BaseMap extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      currentBasemapId: props.currentBasemapId,
    };
    this.changeHandlerBasemap = this.changeHandlerBasemap.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentBasemapId === this.state.currentBasemapId) return;
    this.setState({
      currentBasemapId: nextProps.currentBasemapId,
    });
  }

  changeHandlerBasemap(value) {
    this.setState({
      currentBasemapId: value,
    });
    this.props.changeHandler(value);
  }

  render() {
    const items = this.props.basemaps && this.props.basemaps.length ? this.props.basemaps : [];
    const currentItem = items.filter(bm => bm.id.toString() === this.state.currentBasemapId.toString())[0];
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)';
    const highOrLow = () => {
      if (window.devicePixelRatio > 1) {
        return 'high';
      }
      if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
        return 'high';
      }
      return 'low';
    };

    return (
      <div>
      {currentItem ?
        <TileLayer
          subdomains={[1]}
          url={currentItem.tileUrls[highOrLow()]}
          zoomOffset={currentItem.zoomOffset}
          tileSize={currentItem.tileSize}
          attribution={currentItem.attribution || this.props.attribution}
        />
      : null}
      {items.length && this.props.showSwitch ?
        <MapControl position={'topright'}>
          <Switch
            items={items}
            currentItemId={this.state.currentBasemapId}
            changeHandler={this.changeHandlerBasemap}
          />
        </MapControl>
      : null}
      </div>
    );
  }
}

BaseMap.propTypes = {
  basemaps: PropTypes.array,
  currentBasemapId: PropTypes.string,
  changeHandler: PropTypes.func,
  showSwitch: PropTypes.bool,
  attributtion: PropTypes.string,
};

BaseMap.defaultProps = {
  basemaps: [],
  currentBasemapId: '',
  changeHandler: () => {},
  showSwitch: true,
  attributtion: '',
};

export default BaseMap;



/** WEBPACK FOOTER **
 ** ./core_components/Basemap/index.js
 **/